<template>
  <ul class="notice-list">
    <li class="notice-item">
      <a class="notice-box" :href="'/notice' | hostBuild('home')" target="_blank" title="系统通知">
        <span class="notice-name">系统通知</span>
        <span class="notice-num" v-if="systemNoticeCount">{{ systemNoticeCount | noticeNumFilter }}</span>
      </a>
    </li>
    <li class="notice-item">
      <a class="notice-box" :href="'/notice?type=1' | hostBuild('home')" target="_blank" title="评论和@">
        <span class="notice-name">评论和@</span>
        <span class="notice-num" v-if="atUserAndCommentCount">{{ atUserAndCommentCount | noticeNumFilter }}</span>
      </a>
    </li>
    <li class="notice-item">
      <a class="notice-box" :href="'/notice?type=2' | hostBuild('home')" target="_blank" title="新增关注">
        <span class="notice-name">新增关注</span>
        <span class="notice-num" v-if="attentionToMeCount">{{ attentionToMeCount | noticeNumFilter }}</span>
      </a>
    </li>
    <li class="notice-item">
      <a class="notice-box" :href="'/notice?type=3' | hostBuild('home')" target="_blank" title="获赞">
        <span class="notice-name">获赞</span>
        <span class="notice-num" v-if="thumbUpCount">{{ thumbUpCount | noticeNumFilter }}</span>
      </a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'CardNotice',
  props: {
    // @我的数量
    atUserCount: Number,
    // 评论我的数量
    commentNoticeCount: Number,
    // 通知数量
    systemNoticeCount: Number,
    // 赞我的数量
    thumbUpCount: Number,
    // 关注我的数量
    attentionToMeCount: Number,
  },
  computed: {
    // 评论和@我的数量
    atUserAndCommentCount() {
      return this.commentNoticeCount + this.atUserCount;
    },
  },
  filters: {
    noticeNumFilter(num) {
      return num > 99 ? '99+' : num;
    },
  },
};
</script>
<style lang="less" scoped>
.notice-list {
  padding: 10px 0;
}
.notice-box {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background-color: #fff;
  &:hover {
    background: #f9f9f9;
  }
}
.notice-name {
  font-size: 14px;
  color: #222222;
}
.notice-num {
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #fff;
  background: #e43a3a;
  padding: 0 5px;
  border-radius: 8px;
}
</style>
